"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_Facebook__mono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "410FE6D7-E252-400B-A697-53CC4A77CD85"), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-201.000000, -212.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-White-/-Facebook-/-Medium",
    transform: "translate(201.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5411765,0.941176471 L5.45882353,0.941176471 C2.96658824,0.948705882 0.948705882,2.96658824 0.941176471,5.45882353 L0.941176471,26.5411765 C0.948705882,29.0334118 2.96658824,31.0512941 5.45882353,31.0588235 L16.9411765,31.0588235 L16.9411765,18.4470588 L14.3058824,18.4470588 L14.3058824,14.1176471 L16.9411765,14.1176471 L16.9411765,11.5907765 C16.9411765,8.1152 18.3115294,6.02352941 22.3774118,6.02352941 L25.9764706,6.02352941 L25.9764706,10.3529412 L23.8592,10.3529412 C22.2976,10.3529412 22.2117647,10.8664471 22.2117647,12.0018824 L22.2117647,14.1176471 L25.8544941,14.1176471 L25.3967059,18.4470588 L22.2117647,18.4470588 L22.2117647,31.0588235 L26.5411765,31.0588235 C29.0334118,31.0512941 31.0512941,29.0334118 31.0588235,26.5411765 L31.0588235,5.45882353 C31.0512941,2.96658824 29.0334118,0.948705882 26.5411765,0.941176471",
    id: "Fill-1"
  })))));
}

var _default = ic_Facebook__mono;
exports.default = _default;